import { createModalStoreFactory } from '@/features/_shared/stores/create-modal.store';
import { useShallow } from 'zustand/shallow';
import type {
  IUpdateCareNotificationModalProps,
  TUpdateCareNotificationModalType,
} from '@/features/notifications/components/modals/update-care-notification-modal/update-care-notification-modal';
import type {
  IUpdateTicketingNotificationModalProps,
  TUpdateTicketingNotificationModalType,
} from '@/features/notifications/components/modals/update-ticketing-notification-modal/update-ticketing-notification-modal';

// --------- Notification Modal Root Types ---------
export type TNotificationModalRootTypes = TUpdateCareNotificationModalType | TUpdateTicketingNotificationModalType;

// --------- Notification Modal Root Props ---------
type TNotificationModalRootProps = {
  UpdateCareNotificationModal: IUpdateCareNotificationModalProps;
  UpdateTicketingNotificationModal: IUpdateTicketingNotificationModalProps;
};

export const useNotificationModalRootStore = createModalStoreFactory<
  TNotificationModalRootTypes,
  TNotificationModalRootProps
>();

export const useNotificationModalRootActionsStore = () =>
  useNotificationModalRootStore(useShallow((state) => state.actions));
